/**
=========================================================
* Soft UI Dashboard React - v3.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Soft UI Dashboard React Base Styles
import colors from "assets/theme/base/colors";
import borders from "assets/theme/base/borders";
import boxShadows from "assets/theme/base/boxShadows";

// Soft UI Dashboard React Helper Function
import rgba from "assets/theme/functions/rgba";

const { black, white } = colors;
const { borderWidth, borderRadius } = borders;
const { xxl } = boxShadows;

const card = {
  styleOverrides: {
    root: {
      display: "flex",
      flexDirection: "column",
      position: "relative",
      minWidth: 0,
      wordWrap: "break-word",
      background: "linear-gradient(180deg, #fff, #fffdf2)",
      backgroundClip: "border-box",
      border: `1px solid ${rgba(0, 0, 0, 0.15)}`,
      borderRadius: borderRadius.xl,
      boxShadow: `0 30px 70px ${rgba(black.main, 0.12)}, inset 0 0 0 1px ${rgba(0, 0, 0, 0.15)}`,
    },
  },
};

export default card;
